<template>
  <div class="bodyContent"><router-view /></div>
</template>

<style lang="scss" scoped>
#app {
  margin: 0;
  padding: 0;
}
.bodyContent {
  width: 100%;
  height: 100vh;
  background-color: #f1f1f1;
}
@media screen and (min-width: 600px) {
  body {
    font-size: 16px; /* 设置PC端显示的最大字体大小为 16px */
  }
}
</style>
<script setup>
// 获取网页基本信息
import {web_base_config} from "@/api";
import {onMounted} from "vue";
import {showFailToast} from "vant";

const get_web_base_config = async () => {
  const res = await web_base_config()
  if (res.data.code !== 200) return showFailToast({message: `${res.data.message}`, type: 'error'})
  // console.log(res);
  // header_component_state.client_url = res.data.data['visit_domain'] + '/fwcx/'
  document.title = res.data.data['site_name'] || ""
  // console.log(header_component_state.client_url)
}
onMounted(() => {
  get_web_base_config();
})
</script>
